/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Modal dialog
//
// This allows arbitrary JS to be attached to data-action inside the view,
// powered by a template.

namespace('Slzr.UI', function(exports, top) {
  let $;
  const jQuery = ($ = Slzr.jQuery);

  return (function() {
    const Cls = (exports.Modal = class Modal {
      static initClass() {
        this.prototype.default_options = {
          // template name to use for the modal content
          template: null,
          // handlers for actions defined in content
          actions: null,
          // Callback when modal is closed
          onClose: null,
          // Parameters for template evaluation
          params: {},
          // Callback after the content is created, to attach custom event handlers, etc.
          afterContentCreated: null
        };
      }

      // Create and display
      constructor(options) {
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.destroy = this.destroy.bind(this);
        this.onAction = this.onAction.bind(this);
        this.onFormAction = this.onFormAction.bind(this);
        this._onClose = this._onClose.bind(this);
        this.template = options.template;
        this.actions = options.actions || {};
        this.formActions = options.formActions || {};
        this.onClose = options.onClose;
        this.params = options.params || {};
        this.afterContentCreated = options.afterContentCreated;

        this._createModalContent();
        this.show();
      }

      // Show the modal
      show() {
        return openIbox(`#${this.modal_id}`, {onClosed: this._onClose});
      }

      // Hide the modal
      hide() {
        return hideIbox();
      }

      // Destroy the modal
      destroy() {
        this.modal_container_div.remove();
        return this.modal_container_div = (this.modal_div = (this.modal_id = null));
      }

      // Action handler
      onAction(element, event) {
        const name = $(element).data('action');
        if (this.actions[name] != null) {
          return this.actions[name](this, element, event);
        } 
          // Action not defined, so true
          return true;
        
      }

      onFormAction(element, event) {
        const name = $(element).data('action');
        if (this.formActions[name] != null) {
          return this.formActions[name](this, element, event);
        } 
          // Action not defined, so true
          return true;
        
      }

      // Close handler
      _onClose() {
        if (typeof this.onClose === 'function') {
          this.onClose();
        }
        return this.destroy();
      }

      // Create the modal content
      _createModalContent() {
        // Create the HTML element
        this.modal_id = `localist_modal_${  Math.floor(Math.random() * 1000000000)}`;

        this.modal_container_div = $('<div></div>')
          .css('display', 'none')
          .html(JST[this.template](this.params));

        this.modal_container_div.children().attr('id', this.modal_id);
        this.modal_div = this.modal_container_div.children();

        $(document.body).append(this.modal_container_div);

        const self = this;
        this.modal_container_div.find('[data-action]').on('click', function(evt) {
          return self.onAction(this, evt);
        });

        this.modal_container_div.find('form[data-action]').on('submit', function(evt) {
          return self.onFormAction(this, evt);
        });

        if (this.afterContentCreated) { this.afterContentCreated(this, this.modal_container_div); }

        return this.modal_div;
      }
    });
    Cls.initClass();
    return Cls;
  }());
});